import { useMessages } from '../i18n/LanguageProvider';
import { APPEARANCES } from '../state/app-data';
import { useAppData } from '../state/AppDataProvider';

/**
 * DE: Wahl zwischen „wie am Telefon“, hell und dunkel; ohne gespeicherte Wahl gilt das Telefon.
 * EN: Choice between "as on the phone", light and dark; without a stored choice the phone applies.
 */
export function AppearanceSection() {
  const { data, dispatch } = useAppData();
  const { t } = useMessages();
  const current = data.appearance ?? 'system';
  return (
    <section className="app-card">
      <h2>{t.appearanceTitle}</h2>
      <div className="app-toggle">
        {APPEARANCES.map((appearance) => (
          <button
            key={appearance}
            type="button"
            aria-pressed={appearance === current}
            onClick={() => dispatch({ type: 'set-appearance', appearance })}
          >
            {t.appearanceChoices[appearance]}
          </button>
        ))}
      </div>
    </section>
  );
}
